/* eslint-disable */

import { makeStyles, Switch } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Delete, LinkSharp, Visibility } from "@material-ui/icons";
import Edit from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import TablePaginate from "components/TablePaginate/TablePaginate";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { bannerService } from "services/bannerService";
import { collectionService } from "services/collectionService";

const FE_LINK = process.env.REACT_APP_FE_LINK;

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function BannerIndex() {
  const classes = useStyles();
  const [size] = React.useState(10);
  const [open, setOpen] = useState(false);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Thumbnail",
        accessor: "image",
        Cell: Thumbnail,
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Order",
        accessor: "order",
      },
      {
        Header: "Mint link",
        accessor: "mintLink",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <>
              <Action
                cell={cell}
                setItems={setItems}
                onCloseModal={handleClose}
              ></Action>
            </>
          );
        },
      },
    ],
    [handleClose, open]
  );

  function Thumbnail({ cell }) {
    return <img src={cell.value} alt="" style={{ height: "50px" }} />;
  }

  Thumbnail.propTypes = {
    cell: PropTypes.any,
  };

  const handleRefresh = useCallback(() => {
    setIsRefresh(true);
  }, [isRefresh]);

  async function fetchCollections() {
    const payload = {
      search,
      page,
      size,
      sortBy: "order",
      sortType: "asc",
    };
    try {
      const { data } = await bannerService.list(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
      setIsRefresh(false);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchCollections();
  }, [page, search]);

  return (
    <div>
      {confirm}
      <Link to="/admin/banner-edit">
        <Button color="info">Create new Banner</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

IsHot.propTypes = {
  cell: PropTypes.any,
};

function IsHot({ cell }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(cell.value);
  }, [cell]);

  function onChange(e) {
    setChecked(e.target.checked);
    toogleChecked(e.target.checked);
  }

  async function toogleChecked(isChecked) {
    const id = cell.row.original.id;
    try {
      const { data } = await collectionService.update(id, { isHot: isChecked });
      console.log(data);
      toast.success("Updated collections");
    } catch (e) {
      toast.error(e.response.data.message[0]);
    }
  }
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

IsActivated.propTypes = {
  cell: PropTypes.any,
};

function IsActivated({ cell }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(cell.value);
  }, [cell]);

  function onChange(e) {
    setChecked(e.target.checked);
    toogleChecked(e.target.checked);
  }

  async function toogleChecked(isChecked) {
    const id = cell.row.original.id;
    try {
      const { data } = await collectionService.update(id, {
        activated: isChecked,
      });
      console.log(data);
      toast.success("Updated collections");
    } catch (e) {
      toast.error(e.response.data.message[0]);
    }
  }
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

function Action({ cell, onCloseModal, setItems }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);

  const handleOpenDel = () => {
    setOpenDialogDel(true);
  };

  const handleCloseDel = () => {
    setOpenDialogDel(false);
  };

  const handleDelete = async (id) => {
    await bannerService.remove(id);
    setItems((prev) => prev.filter((banner) => banner._id !== id));
    handleCloseDel();
  };

  return (
    <div className="actions-right">
      <Button
        justIcon
        round
        simple
        color="warning"
        className="edit"
        onClick={() => handleOpenDel()}
      >
        <Delete />
      </Button>

      <Dialog
        open={openDialogDel}
        onClose={handleCloseDel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm remove banner"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDel} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(cell.row.original._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Link to={"/admin/banner-edit/" + cell.row.original._id}>
        <Button justIcon round simple color="primary" className="edit">
          <Edit />
        </Button>
      </Link>

      <a href={`${FE_LINK}/banner/${cell.row.original._id}`} target="_blank">
        <Button justIcon round simple color="success" className="edit">
          <LinkSharp />
        </Button>
      </a>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  onCloseModal: PropTypes.any,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function View({ cell }) {
  return (
    <div className="actions-right">
      <Link to={"/admin/banner/" + cell.row.original.id}>
        <Button justIcon round simple color="success" className="edit">
          <Visibility />
        </Button>
      </Link>
    </div>
  );
}

View.propTypes = {
  cell: PropTypes.any,
};
